<template>
  <div class="app-shell">
    <div v-if="authLoading" class="auth-state">
      <div class="auth-panel">
        <div class="auth-spinner"></div>
        <h1>特教求索</h1>
        <p>正在校验登录状态...</p>
      </div>
    </div>

    <div v-else class="app-frame">
      <ChatWindow
        :current-user="currentUser"
        :auth-error="authError"
        @login="goLogin"
        @logout="handleLogout"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import ChatWindow from './components/ChatWindow.vue';
import { apiService } from './utils/api';

const authLoading = ref(true);
const authError = ref('');
const currentUser = ref(null);

const goLogin = () => {
  apiService.jumpToLogin();
};

const handleLogout = () => {
  apiService.logout();
};

onMounted(async () => {
  apiService.consumeTokenFromUrl();

  if (!apiService.hasLoginToken()) {
    authError.value = '登录后可继续提问，并自动同步本浏览器里的旧聊天记录。';
    authLoading.value = false;
    return;
  }

  try {
    currentUser.value = await apiService.getCurrentUser();
  } catch (error) {
    console.error('Auth check failed:', error);
    authError.value = '登录状态已失效，请重新登录后继续使用特教求索。';
  } finally {
    authLoading.value = false;
  }
});
</script>

<style lang="scss">
@import './styles/variables.scss';

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
}

body {
  font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Microsoft YaHei', Roboto, Helvetica, Arial, sans-serif;
  background: #f4f7fb;
  color: $text-color;
  -webkit-font-smoothing: antialiased;
}

.app-shell {
  min-height: 0;
  height: 100dvh;
  height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
  background: linear-gradient(180deg, #f8fbff 0%, #f4f7fb 42%, #eef3f8 100%);
  overflow: hidden;
}

.auth-state {
  min-height: 100dvh;
  min-height: calc(var(--vh, 1vh) * 100);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $spacing-lg;
}

.auth-panel {
  width: min(420px, 100%);
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(148, 163, 184, 0.26);
  border-radius: $border-radius-md;
  padding: $spacing-xl;
  text-align: center;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.08);

  h1 {
    color: #12324a;
    font-size: 1.5rem;
    margin: 0 0 $spacing-sm;
  }

  p {
    color: #586778;
    line-height: 1.6;
    margin-bottom: $spacing-lg;
  }

  button {
    border: none;
    border-radius: $border-radius-sm;
    background: $primary-color;
    color: #fff;
    cursor: pointer;
    font-weight: 600;
    padding: 10px $spacing-lg;
  }
}

.auth-spinner {
  width: 34px;
  height: 34px;
  border: 3px solid rgba($primary-color, 0.18);
  border-top-color: $primary-color;
  border-radius: 50%;
  animation: auth-spin 0.8s linear infinite;
  margin: 0 auto $spacing-md;
}

@keyframes auth-spin {
  to {
    transform: rotate(360deg);
  }
}

.app-frame {
  width: 100%;
  margin: 0;
  padding: 0;
  height: 100dvh;
  height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
  min-height: 0;
  display: block;
  overflow: hidden;
}
</style> 
